import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { DeliveryScheduleTemplate } from 'components/Templates'

const DeliverySchedule: FC = () => {
  return (
    <Layout headline={'お届け可能日設定'} iconPath={'/icon/white/reservation.svg'} title={'お届け可能日設定'}>
      <DeliveryScheduleTemplate />
    </Layout>
  )
}

export default DeliverySchedule
